import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Signup from './components/Signup';

import React, { useCallback, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import SkeletonTable from './components/SkeletonTable';
import Footer from './components/Footer';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // let user = null;
  const setUserCallback = useCallback((user) => {
    setUser(user);
    setLoading(false);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUserCallback);

    return () => unsubscribe();
  }, [setUserCallback]);

  const [isMozilla, setIsMozilla] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsMozilla(userAgent.indexOf('firefox') !== -1);
  }, []);
  return (
    <BrowserRouter>
      <Navbar />
      {isMozilla && (
        <p className="text-sm px-3 text-center bg-yellow-400 text-yellow-950 animate__animated animate__fadeIn">
          This site works best in Chrome.
        </p>
      )}
      <Routes>
        {!loading ? (
          <>
            {!user ? (
              <>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Home user={user} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            )}
          </>
        ) : (
          // Render a loading state while user data is being fetched
          <Route path="/" element={<SkeletonTable />} />
        )}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
